import { render, staticRenderFns } from "./StartDocumentItem.vue?vue&type=template&id=70bb8a3d&scoped=true&"
import script from "./StartDocumentItem.vue?vue&type=script&lang=ts&"
export * from "./StartDocumentItem.vue?vue&type=script&lang=ts&"
import style0 from "./StartDocumentItem.vue?vue&type=style&index=0&id=70bb8a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb8a3d",
  null
  
)

export default component.exports